import React from "react";
import { FunctionComponent } from "react";

interface AdminProps {}

const Admin: FunctionComponent<AdminProps> = () => {
  return <div></div>;
};

export default Admin;
